function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EquatorialGuineaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_3677",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_3677)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21.432H24.576V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_3677",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "25",
      height: "19",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21.432H24.576V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_3677)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9.144H24.576V3H0Z",
        fill: "#009D00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 9.144V15.288H24.576V9.144H0Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15.288V21.432H24.576V15.288H0Z",
        fill: "#F80000"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21.432L6.144 12.3327L0 3Z",
      fill: "#0075D5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_621_3677",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "7",
      height: "19",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21.432L6.144 12.3327L0 3Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask2_621_3677)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.55 10.71H14.562V12.984C14.562 13.8157 13.8878 14.49 13.056 14.49C12.2243 14.49 11.55 13.8157 11.55 12.984V10.71Z",
      stroke: "#373737",
      strokeWidth: "0.06"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.8459 12.1851C12.8459 12.1851 12.691 14.0017 12.5363 14.1118C12.3817 14.2218 13.2774 14.2768 13.363 14.1943C13.4486 14.1118 12.9724 12.6315 13.1362 12.1851C13.3 11.7388 13.5639 11.7026 13.5639 11.7026C13.5639 11.7026 13.2312 11.6323 13.1362 11.7662C13.0411 11.9002 12.7577 11.7026 12.7577 11.7026L12.8459 12.1851Z",
      fill: "#6F3E1D"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.812 12.0825H12.6928C12.6928 12.0825 12.6121 12.3979 12.427 12.2402C12.242 12.0825 11.9808 12.1381 11.9808 12.1381C11.9808 12.1381 12.0043 11.9493 12.2884 11.8743C12.5726 11.7992 12.6928 11.1899 12.6928 11.1899C12.6928 11.1899 13.095 11.0402 13.3396 11.347C13.5843 11.6537 13.9289 11.5228 13.9289 11.5228C13.9289 11.5228 14.1808 11.6661 14.0549 11.8743C13.9289 12.0825 13.7141 12.2348 13.5269 12.0825C13.3396 11.9302 12.812 12.0825 12.812 12.0825Z",
      fill: "#009D29"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.189 9.81797L11.1915 9.82915L11.1755 9.81436L11.0105 9.66195L10.9899 9.88561L11.0013 9.88666L10.9823 9.89732L10.7863 10.0071L10.9927 10.0959L10.9972 10.0853L11.0015 10.1067L11.0453 10.327L11.1935 10.1582L11.1849 10.1506L11.2065 10.1532L11.4296 10.1795L11.3148 9.98642L11.3049 9.99227L11.3141 9.97248L11.408 9.76847L11.189 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.9569 9.81797L11.9594 9.82915L11.9434 9.81436L11.7784 9.66195L11.7578 9.88561L11.7692 9.88666L11.7502 9.89732L11.5543 10.0071L11.7606 10.0959L11.7651 10.0853L11.7694 10.1067L11.8133 10.327L11.9614 10.1582L11.9528 10.1506L11.9745 10.1532L12.1975 10.1795L12.0827 9.98642L12.0729 9.99227L12.082 9.97248L12.176 9.76847L11.9569 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.725 9.81797L12.7275 9.82915L12.7115 9.81436L12.5465 9.66195L12.5259 9.88561L12.5373 9.88666L12.5183 9.89732L12.3223 10.0071L12.5287 10.0959L12.5332 10.0853L12.5375 10.1067L12.5813 10.327L12.7295 10.1582L12.7209 10.1506L12.7425 10.1532L12.9656 10.1795L12.8508 9.98642L12.841 9.99227L12.8501 9.97248L12.944 9.76847L12.725 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.4929 9.81797L13.4954 9.82915L13.4794 9.81436L13.3144 9.66195L13.2938 9.88561L13.3052 9.88666L13.2862 9.89732L13.0903 10.0071L13.2966 10.0959L13.3011 10.0853L13.3054 10.1067L13.3493 10.327L13.4974 10.1582L13.4888 10.1506L13.5105 10.1532L13.7335 10.1795L13.6188 9.98642L13.6089 9.99227L13.618 9.97248L13.712 9.76847L13.4929 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.261 9.81797L14.2635 9.82915L14.2475 9.81436L14.0825 9.66195L14.0619 9.88561L14.0733 9.88666L14.0543 9.89732L13.8583 10.0071L14.0647 10.0959L14.0692 10.0853L14.0735 10.1067L14.1174 10.327L14.2655 10.1582L14.2569 10.1506L14.2785 10.1532L14.5016 10.1795L14.3868 9.98642L14.377 9.99227L14.3861 9.97248L14.4801 9.76847L14.261 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.0289 9.81797L15.0314 9.82915L15.0154 9.81436L14.8505 9.66195L14.8298 9.88561L14.8412 9.88666L14.8222 9.89732L14.6263 10.0071L14.8326 10.0959L14.8372 10.0853L14.8414 10.1067L14.8853 10.327L15.0334 10.1582L15.0248 10.1506L15.0465 10.1532L15.2695 10.1795L15.1548 9.98642L15.1449 9.99227L15.154 9.97248L15.248 9.76847L15.0289 9.81797Z",
      fill: "#FFD500",
      stroke: "#212124",
      strokeWidth: "0.03"
    })]
  })]
}));
//# sourceMappingURL=EquatorialGuinea.js.map